// Schema definitions for editable static pages. Add a new entry here (and a
// matching default in backend DEFAULT_PAGE_CONTENT) to expose a new page in the
// admin "Contenido" tab — no DB schema changes needed.
// field types: "text" | "textarea" | "image"

export const PAGE_SCHEMAS = [
  {
    key: "home",
    label: "Inicio",
    fields: [
      { key: "hero_eyebrow", label: "Hero · Texto superior", type: "text" },
      { key: "hero_image", label: "Hero · Imagen de fondo", type: "image" },
      { key: "featured_overline", label: "Destacados · Etiqueta", type: "text" },
      { key: "featured_title", label: "Destacados · Título", type: "text" },
      { key: "craft_overline", label: "Artesanía · Etiqueta", type: "text" },
      { key: "craft_title", label: "Artesanía · Título", type: "text" },
      { key: "craft_text_1", label: "Artesanía · Párrafo 1", type: "textarea" },
      { key: "craft_text_2", label: "Artesanía · Párrafo 2", type: "textarea" },
      { key: "craft_cta", label: "Artesanía · Botón", type: "text" },
      { key: "craft_image", label: "Artesanía · Imagen", type: "image" },
      { key: "new_overline", label: "Nuevos · Etiqueta", type: "text" },
      { key: "new_title", label: "Nuevos · Título", type: "text" },
    ],
  },
  {
    key: "configurator",
    label: "Diseña tu Reloj",
    fields: [
      { key: "badge", label: "Insignia", type: "text" },
      { key: "overline", label: "Etiqueta", type: "text" },
      { key: "title", label: "Título", type: "text" },
      { key: "subtitle", label: "Subtítulo", type: "textarea" },
      { key: "cta_overline", label: "CTA · Etiqueta", type: "text" },
      { key: "cta_title", label: "CTA · Título", type: "text" },
      { key: "cta_text", label: "CTA · Texto", type: "textarea" },
      { key: "cta_button", label: "CTA · Botón", type: "text" },
    ],
  },
  {
    key: "contact",
    label: "Contacto",
    fields: [
      { key: "overline", label: "Etiqueta", type: "text" },
      { key: "title", label: "Título", type: "text" },
      { key: "subtitle", label: "Subtítulo", type: "textarea" },
      { key: "whatsapp_title", label: "WhatsApp · Título", type: "text" },
      { key: "whatsapp_text", label: "WhatsApp · Texto", type: "textarea" },
      { key: "instagram_title", label: "Instagram · Título", type: "text" },
      { key: "instagram_text", label: "Instagram · Texto", type: "textarea" },
      { key: "footer_note", label: "Nota inferior", type: "textarea" },
    ],
  },
];
